import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@lhd/app/store";

const projectStatusFilterSelector = (state: RootState) =>
  state.projectStatusFilter;

export const getIsOpen = createSelector(
  projectStatusFilterSelector,
  (state) => state.isOpen,
);
